import { default as Vuex, Module } from "vuex";

type PopupDialogMode = "ok" | "yesNo";

class PopupDialogModuleState {
	[key: string]: any;
	popupVisible: boolean = false;
	popupMessage: string = "";
	mode: PopupDialogMode;
	yesAction: Function;
}

class PopupDialogModule implements Module<PopupDialogModuleState, any> {
	namespaced = true;
	state: PopupDialogModuleState = new PopupDialogModuleState();
	mutations = {
		MUTATE_POPUP_DIALOG_STATE(state: PopupDialogModuleState, payload: {key: string, value: any}) {
			state[payload.key] = payload.value;
		}
	}
}

const popupDialotModule: PopupDialogModule = new PopupDialogModule();

export default popupDialotModule;
